import { listConfig, OrgPricingResponse, contactCustomerSupport } from '@goldcast/api/backend';

const actions = {
  async getOrgPricingConfig({ commit, dispatch }, orgId) {
    return new Promise(resolve => {
      listConfig({
        queryParams: {
          organization_id: orgId
        }
      })
        .then(response => {
          if (typeof response !== 'object' || response === null) {
            throw new Error('Invalid response: Not a valid JSON object');
          }
          const typedResponse = response as OrgPricingResponse;
          commit('setOrgPricingConfig', typedResponse);
          resolve(typedResponse);
        })
        .catch(error => {
          dispatch(
            'studioToast/triggerToast',
            {
              msg: JSON.parse(error)[0]?.message || 'An error occurred!',
              mode: 'error'
            },
            { root: true }
          );
        });
    });
  },
  async contactCustomerSupport({ dispatch, rootGetters }, text: string) {
    const orgID = rootGetters['org/getCurrentOrgId'];
    return new Promise((resolve, reject) => {
      contactCustomerSupport({
        id: orgID,
        body: {
          text
        }
      })
        .then(() => {
          dispatch(
            'studioToast/triggerToast',
            {
              msg: 'Thank you for reaching out to Goldcast. A member of our dedicated customer support team will be in touch with you shortly.',
              mode: 'success'
            },
            { root: true }
          );
          resolve('Success');
        })
        .catch(error => {
          dispatch(
            'studioToast/triggerToast',
            {
              msg: 'An error occurred!',
              mode: 'error'
            },
            { root: true }
          );
          reject(error);
        });
    });
  }
};

export default actions;
